// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Info_drawer__Ga\\+Mk {
  position: fixed;
  top: 100px;
  right: -400px;
  width: 350px;
  height: 100%;
  background-color: var(--color-bg-panel);
  color: var(--color-text);
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  transition: right 0.3s ease-in-out;
  z-index: 999;
  padding: 20px;
}

.Info_drawer__Ga\\+Mk.Info_open__yzsD0 {
  right: 0;
}

/* Fullscreen drawer for mobile devices */
@media (max-width: 768px) {
  .Info_drawer__Ga\\+Mk {
    top: 100px;
    right: -100%;
    width: 100%;
    height: 100%;
    padding: 15px;
  }

  .Info_drawer__Ga\\+Mk.Info_open__yzsD0 {
    right: 0;
  }
}

  
  .Info_drawerHeader__ktQxc {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .Info_drawerTitle__Ey3QZ {
    font-size: 18px;
    font-weight: bold;
  }
  
  .Info_closeIcon__-lSUC {
    font-size: 20px;
    cursor: pointer;
    font-weight: bold;
    position: absolute; /* Add positioning for \`right\` to work */
    right: 10px; /* Adjust as needed */
    top: 10px; /* Optional: position it near the top */
  }
  
  
  .Info_infoItem__l9d1- {
    margin-bottom: 20px;
  }
  
  .Info_infoItem__l9d1- h4 {
    font-size: 16px;
    margin-bottom: 10px;
  }
  
  .Info_infoItem__l9d1- p {
    font-size: 14px;
    line-height: 1.5;
  }
  
  ul {
    margin-top: 10px;
    padding-left: 20px;
  }
  
  ul li {
    font-size: 14px;
    margin-bottom: 5px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Chart/Info/css/Info.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,UAAU;EACV,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uCAAuC;EACvC,wBAAwB;EACxB,yCAAyC;EACzC,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,QAAQ;AACV;;AAEA,yCAAyC;AACzC;EACE;IACE,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;AACF;;;EAGE;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB,EAAE,wCAAwC;IAC5D,WAAW,EAAE,qBAAqB;IAClC,SAAS,EAAE,uCAAuC;EACpD;;;EAGA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB","sourcesContent":[".drawer {\n  position: fixed;\n  top: 100px;\n  right: -400px;\n  width: 350px;\n  height: 100%;\n  background-color: var(--color-bg-panel);\n  color: var(--color-text);\n  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);\n  overflow-y: auto;\n  transition: right 0.3s ease-in-out;\n  z-index: 999;\n  padding: 20px;\n}\n\n.drawer.open {\n  right: 0;\n}\n\n/* Fullscreen drawer for mobile devices */\n@media (max-width: 768px) {\n  .drawer {\n    top: 100px;\n    right: -100%;\n    width: 100%;\n    height: 100%;\n    padding: 15px;\n  }\n\n  .drawer.open {\n    right: 0;\n  }\n}\n\n  \n  .drawerHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .drawerTitle {\n    font-size: 18px;\n    font-weight: bold;\n  }\n  \n  .closeIcon {\n    font-size: 20px;\n    cursor: pointer;\n    font-weight: bold;\n    position: absolute; /* Add positioning for `right` to work */\n    right: 10px; /* Adjust as needed */\n    top: 10px; /* Optional: position it near the top */\n  }\n  \n  \n  .infoItem {\n    margin-bottom: 20px;\n  }\n  \n  .infoItem h4 {\n    font-size: 16px;\n    margin-bottom: 10px;\n  }\n  \n  .infoItem p {\n    font-size: 14px;\n    line-height: 1.5;\n  }\n  \n  ul {\n    margin-top: 10px;\n    padding-left: 20px;\n  }\n  \n  ul li {\n    font-size: 14px;\n    margin-bottom: 5px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drawer": `Info_drawer__Ga+Mk`,
	"open": `Info_open__yzsD0`,
	"drawerHeader": `Info_drawerHeader__ktQxc`,
	"drawerTitle": `Info_drawerTitle__Ey3QZ`,
	"closeIcon": `Info_closeIcon__-lSUC`,
	"infoItem": `Info_infoItem__l9d1-`
};
export default ___CSS_LOADER_EXPORT___;
